// Copyright © 2026 Qcells. All rights reserved.
//
// This software is proprietary and confidential. Unauthorized use,
// duplication, or distribution of software is strictly prohibited.

import { useQuery } from '@tanstack/react-query';
import { listSites, listRegions } from '../../helios/services/omsService';
import type { OmsSite, OmsRegion } from '../../helios/types/oms';

/** Sites belonging to one organization. Keys live under the 'provisioning'
 * namespace: AuthContext already caches ['oms','sites',...] with a different
 * (snake_case summary) shape, and sharing a key corrupts whichever observer
 * reads last. */
export function useSites(orgId: string | undefined) {
  return useQuery<OmsSite[]>({
    queryKey: ['provisioning', 'sites', orgId],
    queryFn: () => listSites(orgId as string),
    enabled: !!orgId,
  });
}

/** Regions available to place a new site in. A site create needs a regionId. */
export function useRegions(orgId: string | undefined) {
  return useQuery<OmsRegion[]>({
    queryKey: ['provisioning', 'regions', orgId],
    queryFn: () => listRegions(orgId as string),
    enabled: !!orgId,
  });
}
